import React from "react";
import {
  SkeletonAvatar,
  SkeletonButton,
  SkeletonParagraph,
} from "../../components/Skeleton/Skeleton";

export const CommentSkeleton = () => {
  return (
    <div className="comment">
      <div className="d-flex flex-row align-items-start mt-4">
        <div className="me-2 my-1">
          <SkeletonAvatar />
        </div>

        <div className="d-flex flex-column w-100" style={{ marginRight: 42 }}>
          <div className="content flex-grow-1 d-flex flex-column rounded-20 p-4">
            <SkeletonParagraph className="mb-4 w-25" />
            <SkeletonParagraph row={3} />
          </div>
          <div className="d-flex flex-row my-3 ms-3">
            <SkeletonButton width={80} className="me-3"/>
            <SkeletonButton width={80} className="me-3"/>
            <SkeletonButton width={80} />
          </div>
        </div>
      </div>
    </div>
  );
};
